import { a as setMode } from './index-34617187.js';

const version = "1.0.0";

/**
 * set mode to 'default' to select default stylesheet when styleUrls used
 * @see "components/bxf-data-viz/bxf-data-viz.tsx"
 * https://stenciljs.com/docs/component#styleurls
 */
setMode(() => 'default');
const appGlobalScript = () => {
    const win = window;
    const presetConfig = win['bxfWebComponents'];
    win['bxfWebComponents'] = {
        name: '@blk/bxf-web-components',
        version: version,
        ...presetConfig,
    };
};

const globalScripts = appGlobalScript;

export { globalScripts as g };
